<template lang="pug">
  div
    b-form(inline)
        label.mr-2 Logged in as
        b-form-select(v-model="selected" :options="options" size="sm" @change="assignRole()")
</template>

<script>
export default {
    name: 'roleSelect',
    components: {
    },
    data(){
        return{
            selected: null,
            options: [],
        }
    },
    computed: {
        login_user(){
            return this.$store.state.login_user;
        }
    },
    mounted() {
        this.assignOptions()
    },
    methods: {
        assignOptions() {
            let roles = this.login_user.other_roles;

            for(let role of roles) {
                this.options.push({value: role, text: role.replace(/_/g, ' ')});
            }

            this.selected = this.login_user.role;
        },
        async assignRole() {
            await this.$store.dispatch('patchUser',{userId: this.login_user.id, payload: {role:this.selected}}).then(()=>{
                window.location.reload();
            }).catch(()=>{
                this.selected = this.login_user.role;
            })
            
        }
    }
}
</script>

<style lang="scss">

</style>